import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supportedLngsObj } from "../helpers/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { TRANSLATED_PATHS } from "../redux/config";
import LanguageDisclaimer from "../components/languageDisclaimer";
import axios from "axios";
import { API_URL } from "../redux/config";
function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const location = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [mlids, setMlids] = useState([]);
  let detectedLang = "en";
  useEffect(() => {
    const fetchMLIds = async () => {
      try {
        const res = await axios.get(API_URL + "mlids/");
        setMlids(res.data);
      } catch (err) {
        console.error("Error fetching mlids:", err);
      }
    };
    fetchMLIds();
  }, []); // run once before anything else

  useEffect(() => {
    if (mlids.length === 0) return; // wait until mlids are set

    const path = location.pathname;

    if (path.startsWith("/hindi")) detectedLang = "hindi";
    else if (path.startsWith("/gujarati")) detectedLang = "gujarati";
    else if (path.startsWith("/marathi")) detectedLang = "marathi";

    const combinedpaths = TRANSLATED_PATHS.concat(mlids);

    if (detectedLang === "hindi" && combinedpaths.indexOf(path) === -1) {
      setModalOpen(true);
      return;
    }
    if (detectedLang === "gujarati" && combinedpaths.indexOf(path) === -1) {
      setModalOpen(true);
      return;
    }
    if (detectedLang === "marathi" && combinedpaths.indexOf(path) === -1) {
      setModalOpen(true);
      return;
    }

    if (i18n.language !== detectedLang) {
      i18n.changeLanguage(detectedLang);
    }

    setCurrentLanguage(detectedLang);
  }, [location.pathname, mlids]);

  // useEffect(() => {
  //   axios.get(API_URL + "mlids/").then((res) => {
  //     setMlids(res.data);
  //   });
  // }, [i18n.language]);

  // // useEffect(() => {
  // //   setCurrentLanguage(i18n.language);
  // //   // alert(i18n.language);
  // // }, [i18n.language]);

  // useEffect(() => {
  //   const path = location.pathname;

  //   let detectedLang = "en";
  //   if (path.startsWith("/hi")) detectedLang = "hi";
  //   else if (path.startsWith("/gu")) detectedLang = "gu";

  //   // Combine static + dynamic translated paths
  //   const combinedpaths = TRANSLATED_PATHS.concat(mlids);

  //   // If URL is in Hindi but not translated, revert to English
  //   if (detectedLang == "hi" && combinedpaths.indexOf(path) === -1) {
  //     setModalOpen(true);
  //     return;
  //   }

  //   if (i18n.language !== detectedLang) {
  //     i18n.changeLanguage(detectedLang);
  //   }

  //   setCurrentLanguage(detectedLang);
  // }, [location.pathname, mlids]);

  // useEffect(() => {
  //   const path = location.pathname;

  //   let detectedLang = "en";
  //   if (path.startsWith("/hi")) detectedLang = "hi";
  //   else if (path.startsWith("/gu")) detectedLang = "gu";

  //   if (i18n.language !== detectedLang) {
  //     i18n.changeLanguage(detectedLang);
  //   }

  //   setCurrentLanguage(detectedLang);
  // }, [location.pathname]);

  // const changeLanguage = (lng) => {
  //   const combinedpaths = TRANSLATED_PATHS.concat(mlids);
  //   const cleanPath = location.pathname.replace(/^\/(hi|gu)(\/|$)/, "/");

  //   const targetPath = "/" + lng + cleanPath;
  //   if (lng !== "en" && combinedpaths.indexOf(targetPath) === -1) {
  //     setModalOpen(true);
  //     return;
  //   }

  //   i18n.changeLanguage(lng);
  //   setCurrentLanguage(lng);

  //   if (lng === supportedLngsObj.GUJARATI) navigate("/gu" + cleanPath);
  //   else if (lng === supportedLngsObj.HINDI) navigate("/hi" + cleanPath);
  //   else navigate(cleanPath === "/" ? "/" : cleanPath);
  // };
  const changeLanguage = (lng) => {
    const combinedpaths = TRANSLATED_PATHS.concat(mlids);
    const cleanPath = location.pathname.replace(
      /^\/(hindi|gujarati|marathi)(?=\/|$)/,
      ""
    );
    const normalizedPath = cleanPath.replace(/\/+$/, "") || "/";

    const targetPath = `/${lng}${normalizedPath}`;
    if (lng !== "en" && !combinedpaths.includes(targetPath)) {
      setModalOpen(true);
      return;
    }

    i18n.changeLanguage(lng);
    setCurrentLanguage(lng);

    if (lng === supportedLngsObj.GUJARATI)
      navigate(`/gujarati${normalizedPath}`);
    else if (lng === supportedLngsObj.HINDI)
      navigate(`/hindi${normalizedPath}`);
    else if (lng === supportedLngsObj.MARATHI)
      navigate(`/marathi${normalizedPath}`);
    else navigate(normalizedPath === "/" ? "/" : normalizedPath);
  };

  // if (TRANSLATED_PATHS.indexOf(location.pathname) != -1) {
  return (
    <div className="d-flex justify-center align-center langBox">
      <LanguageDisclaimer
        lng={detectedLang}
        modalOpen={modalOpen}
        closeModal={() => {
          setModalOpen(false);
        }}
      />
      <select
        name="language"
        id="language-selector"
        onChange={(e) => {
          changeLanguage(e.target.value);
        }}
        value={currentLanguage}
      >
        <option value="en">English</option>
        <option value="hindi">हिंदी</option>
        <option value="gujarati">ગુજરાતી</option>
        <option value="marathi">मराठी</option>
      </select>
      {/*     <option value="gu">ગુજરાતી</option> */}
    </div>
  );
  // }
  return null;
}

export default LanguageSwitcher;
